import { render, staticRenderFns } from "./FacetChipSelect.vue?vue&type=template&id=ad5a48ca&scoped=true&"
import script from "./FacetChipSelect.vue?vue&type=script&lang=js&"
export * from "./FacetChipSelect.vue?vue&type=script&lang=js&"
import style0 from "./FacetChipSelect.vue?vue&type=style&index=0&id=ad5a48ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../myscore_frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5a48ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../myscore_frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VChip,VIcon,VSelect})
